import { FiX } from "react-icons/fi";

export default function ConfirmDialog({
  open, title = "Confirm", message, confirmText = "Confirm", cancelText = "Cancel",
  onCancel, onConfirm,
}: {
  open: boolean; title?: string; message: string; confirmText?: string; cancelText?: string;
  onCancel: () => void; onConfirm: () => void;
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/30" onClick={onCancel} />
      <div className="absolute inset-0 grid place-items-center p-4">
        <div className="w-full max-w-md overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl">
          <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3">
            <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
            <button className="grid h-8 w-8 place-items-center rounded-md text-gray-500 hover:bg-gray-100" onClick={onCancel}>
              <FiX />
            </button>
          </div>
          <div className="p-5 text-sm text-gray-700">{message}</div>
          <div className="flex items-center justify-end gap-2 border-t border-gray-200 px-4 py-3">
            <button onClick={onCancel} className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 hover:bg-gray-50">
              {cancelText}
            </button>
            <button onClick={onConfirm} className="rounded-lg bg-red-600 px-3 py-2 text-sm font-semibold text-white hover:bg-red-700">
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
